import {
  CARS_BOOKED_STATE_ASSIGNED,
  CARS_BOOKED_STATE_BLIND_PLUS,
  CARS_BOOKED_STATE_NOT_ASSIGNED,
  isCarsBookedAssigned,
} from 'lib/carsBookedStates'

export const CARS_BOOKED_ROOT = 'cars-booked'

export const CARS_BOOKED_CAR_DETAILS = 'car-details'

export const hasCarsBookedBlindPlusChoice = (car) =>
  !!car?.isBlindSelection ||
  car?.choice === 'first' ||
  car?.assignedState === CARS_BOOKED_STATE_BLIND_PLUS ||
  (car?.blindPrice !== null &&
    car?.blindPrice !== undefined &&
    car?.blindPrice !== '') ||
  !!car?.secondChoice

export const getCarsBookedChoiceKey = (car) =>
  hasCarsBookedBlindPlusChoice(car)
    ? 'blindPlus'
    : car?.firstChoice
    ? 'firstChoice'
    : 'secondChoice'

export const getCarsBookedUrl = (sessionId, partnerId, plate) => {
  const plateValue = plate ? `/${CARS_BOOKED_CAR_DETAILS}/${plate}` : ''

  return !sessionId || !partnerId
    ? `/${CARS_BOOKED_ROOT}`
    : `/${CARS_BOOKED_ROOT}/${sessionId}/${partnerId}${plateValue}`
}

export const getCarsBookedDisplayStatus = (car) =>
  isCarsBookedAssigned(car)
    ? CARS_BOOKED_STATE_ASSIGNED
    : CARS_BOOKED_STATE_NOT_ASSIGNED

export const getCarsBookedStatusColor = (car) =>
  getCarsBookedDisplayStatus(car) === CARS_BOOKED_STATE_NOT_ASSIGNED
    ? 'error'
    : 'primary'

export const getCarsBookedRecapValues = (cars) => {
  const result = cars.reduce(
    (previous, car) => ({
      firstChoice: (previous.firstChoice || 0) + (car.firstChoice ? 1 : 0),
      secondChoice:
        (previous.secondChoice || 0) +
        (hasCarsBookedBlindPlusChoice(car) ? 1 : 0),
      assigned:
        (previous.assigned || 0) +
        (getCarsBookedDisplayStatus(car) === CARS_BOOKED_STATE_ASSIGNED
          ? 1
          : 0),
      notAssigned:
        (previous.notAssigned || 0) +
        (getCarsBookedDisplayStatus(car) === CARS_BOOKED_STATE_NOT_ASSIGNED
          ? 1
          : 0),
      totalValue: (previous.totalValue || 0) + car.price,
      favorites: (previous.favorites || 0) + (car.favorite ? 1 : 0),
    }),
    {}
  )
  result.total = cars.length

  return result
}
